import { jsx as _jsx } from "react/jsx-runtime";
const PreferencesSegment = ({ children, classes = '' }) => (_jsx("div", { className: `flex flex-col ${classes}`, children: children }));
export default PreferencesSegment;
